import { fetcher, ResponseError } from "src/utils/fetcher";
import isBrowser from "src/utils/isBrowser";

export type SessionResponse = {
  /* Custom_user ID */
  id?: number;
  is_logged_in: boolean;
  is_staff?: boolean;
  email?: string;
  signup?: string;
  has_active_zaps?: boolean;
  /* Use `id` for custom_user ID */
  user_id?: number;
  current_account_id?: number;
  first_name?: string;
  last_name?: string;
};

export async function getSession(cookie: string): Promise<SessionResponse> {
  const isClient = isBrowser();
  const baseUrl = isClient ? "" : process.env.NEXT_PUBLIC_ZAPIER_ORIGIN;
  const headers = !isClient && cookie ? { cookie } : undefined;

  try {
    const response = await fetcher<SessionResponse>(
      `${baseUrl}/api/v4/session`,
      {
        method: "GET",
        credentials: "include",
        headers,
      },
    );

    return response;
  } catch (error) {
    console.error(
      `Error fetching session: ${(error as ResponseError)?.message}`,
    );
    return { is_logged_in: false };
  }
}
